export default {
  namespaced: true,
  state: () => ({
    contrato: null,
  }),
  mutations: {
    setContrato(state, payload) {
      state.contrato = payload;
    },
  },
  actions: {},
};
